const domainCampaign = process.env.REACT_APP_DOMAIN_CAMPAIGN;
const domainLadingpage = process.env.REACT_APP_DOMAIN_LANDINGPAGE_API;
const domainUtop = process.env.REACT_APP_DOMAIN_UTOP;
const END_POINTS = {
  CHECK_CAMPAIGN_URL: domainCampaign + "campaigns/current",
  CHECK_PHONE_URL: domainCampaign + "redeem/check-eligible",
  REQUEST_OTP_URL: domainCampaign + "redeem/request-otp",
  VERIFY_OTP_URL: domainCampaign + "redeem",
  GIFTS_ALLOCATED_URL: domainCampaign + "gifts/allocated",
  

  GET_PROVINCES_URL: domainCampaign + "provinces",
  VALIDATE_CODE_URL: domainCampaign + "campaign/validate",
  OTP_LOG_URL: domainCampaign + "campaign/OTPLog",
  REQUEST_LOGIN_URL: domainCampaign + "otp/RequestLogin",
  UPDATE_USER_INFO_URL: domainLadingpage + "Member/UpdateInfo",
  REQUEST_GIGYA_URL: domainCampaign + "Gigya/GigyaRequest",
  EXCHANGE_CODE_URL: domainCampaign + "ExchangeCode",
  GET_REMAINING_URL: domainCampaign + "GetRemainingGift",
  GET_LIST_WINNER_BY_TYPE: domainCampaign + "Winner",
  GET_LIST_PICTURE: domainCampaign + "campaign/awarded/image",
  TOPUP_MOBILE_URL: domainUtop + "gift/Topup",
  GET_REMAINING_PRIZE: domainCampaign + "GetRemainingGift",
  GET_DISTRICTS_URL: domainCampaign + "cms/DistrictsHaveMart",
  GET_MARTS_URL: domainCampaign + "cms/getmarts",
  UPDATE_DELIVERY_URL: domainCampaign + "UpdateProfile",
};

export { END_POINTS };
